import {Toast} from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState, useRef } from "react";
import { CatalogProductNew } from "../../Product/CatalogProductNew/CatalogProductNew";
import { LubematchVariantCard } from "../LubematchProductCard/LubematchVariantCard";
import { useCartContext } from "../../../Context/CartContext";
import styles from './LubematchRecommendation.module.css'

const TIER_PRIORITY = ['Premium', 'Standard', 'Alternative'];
const getTierOrderIndex = (tierName = "") => {
    const idx = TIER_PRIORITY.indexOf(tierName);
    return idx === -1 ? TIER_PRIORITY.length : idx;
};

export const LubematchRecommendation = ({recommendationList, hasSearched = false, loading = false}) => {

    const toast = useRef(null);
    const {cart, getCart} = useCartContext();
    const [groupedRecommendationList, setGroupedRecommendationList] = useState([])

    useEffect(() => {
        const preparedList = prepareRecommendationList();
        setGroupedRecommendationList(preparedList)
    },[cart, recommendationList])

    const prepareRecommendationList = () => {
        const groupedArray = Object.values(
                recommendationList.reduce((acc, item) => {
                    const key = item.DisplayName;
                    if (!acc[key]) {
                    acc[key] = {
                        DisplayName: key,
                        Items: []
                    };
                    }
                    acc[key].Items.push(item);
                    return acc;
                }, {})
            );
        const checkedGroups = groupedArray.map(group => ({
            ...group,
            hasProducts: group.Items.some(item => Array.isArray(item.lkProductList) && item.lkProductList.length > 0 )})
        );
        // Ensure group with DisplayName "Двигун" appears first
        const priorityName = "Двигун";
        const priorityIndex = checkedGroups.findIndex(g => g.DisplayName === priorityName);
        if (priorityIndex > 0) {
            const [priorityGroup] = checkedGroups.splice(priorityIndex, 1);
            checkedGroups.unshift(priorityGroup);
        }
        const actualCart = JSON.parse(getCart());
        
        checkedGroups.forEach((group) => {
            group.Items.sort((a, b) => getTierOrderIndex(a.TierName) - getTierOrderIndex(b.TierName));
            group.Items.forEach((shellProduct) => {
                shellProduct.lkProductList = getListProductCountInCart(actualCart, shellProduct.lkProductList);
            })
        })
        return checkedGroups;
    }
     
    const getListProductCountInCart = (cart, productList = null) => {
        if(cart && productList !== null && productList.length > 0){
            const actualCart = JSON.parse(getCart());
            const prodsInCart = actualCart.BaseOrder;
       
            const filteredProductsWithCountInCart = _.cloneDeep(productList);
       
            filteredProductsWithCountInCart.forEach((product, index) => {
            const findProduct = prodsInCart.find(item => item.id === product.Id)
       
            if(findProduct){
                product.countInCart = findProduct.count;
                    console.log(product.ProductName, product.countInCart)
                }
                else{
                    product.countInCart = 0;
                }
            })
       
            return filteredProductsWithCountInCart;
        }
        return productList;
        
    }

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                <ProgressSpinner strokeWidth="4" />
            </div>
        );
    }

    if(!groupedRecommendationList || !groupedRecommendationList.length)
        return hasSearched ? <div>Не знайдено рекомендацій за вашим авто</div> : null;

    return (
        <div className={styles.recommendationGroupsWrapper}>
            <Toast ref={toast}></Toast>
            {groupedRecommendationList.map((recommendation, index) => {
                if(recommendation.hasProducts){
                    return (
                        <div className={styles.recommendationGroupWrapper} key={index}>
                            <h5 style={{padding:'5px 10px 0px 10px', alignSelf:"center"}}>{recommendation.DisplayName} {recommendation.Items[0].Display_Capacity && <span style={{color:"gray"}}>({recommendation.Items[0].Display_Capacity}л)</span>}</h5>
                            <div className={styles.tierListWrapper}>
                                {recommendation.Items.map((shellProduct, idx) => {
                                    let tierClassName = '';
                                    switch(shellProduct.TierName){
                                        case 'Premium':
                                            tierClassName = styles.tierPremiumLabel;
                                            break;
                                        case 'Standard':
                                            tierClassName = styles.tierStandardLabel;
                                            break;
                                        case 'Alternative':
                                            tierClassName = styles.tierAlternativeLabel;
                                            break;
                                    }

                                    if (shellProduct.lkProductList && shellProduct.lkProductList.length > 0) {
                                        return (
                                            <div className={styles.tierWrapper} key={idx}>
                                                <div className={`${styles.tierLabel} ${tierClassName}`}>{shellProduct.TierName}
                                                    {shellProduct.TierName === 'Premium' ? 
                                                        <div className={styles.sparkContainer}>
                                                            <div className={styles.spark}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                                                    d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                                            </svg>
                                                            </div>
                                                            <div className={styles.spark}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                                                    d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                                            </svg>
                                                            </div>
                                                            <div className={styles.spark}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                                                    d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                                            </svg>
                                                            </div>
                                                        </div>
                                                    : null}
                                                </div>
                                                <div className={styles.productList}>
                                                    {groupProductsByBaseName(shellProduct.lkProductList).map((group, gIdx) => (
                                                        <LubematchVariantCard key={(group[0]?.Id || 'group') + '_' + gIdx} variants={group} toast={toast} />
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                    }
                                    else return null;
                                })}
                            </div>
                        </div>
                    )
                }
                else
                    return (
                        <div className={styles.recommendationGroupWrapper} key={index}>
                            <h5 style={{ alignSelf:"center"}}>{recommendation.DisplayName} {recommendation.Items[0].Display_Capacity && <span style={{color:"gray"}}>({recommendation.Items[0].Display_Capacity}л)</span>}</h5>
                            <div className={styles.emptyState}>
                                <h6>Знайдено співпадіння в базі Shell, але не вдалось нічого запропонувати з нашого каталогу</h6>
                                <h6>Зверніться до нашого тех. спеціаліста для отримання більш детальної консультації</h6>
                                <div>Запропоновані продукти:
                                    {recommendation.Items.map((shellProduct, idx) => (
                                        <div key={idx}>
                                            <span style={{fontWeight:'600'}}>{shellProduct.ShellProductName}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )
            })}
        </div>
    )
}

// Groups products that have identical base names (ignoring trailing volume like ", 5л")
function groupProductsByBaseName(list = []){
    if(!Array.isArray(list) || list.length === 0) return [];
    const normalize = (name) => {
        if(!name) return '';
        // remove trailing comma + volume like ", 5л" or ", 5 л" or ", 5.5л"
        const trimmed = name.trim();
        const withoutVolume = trimmed.replace(/,\s*\d+(?:[\.,]\d+)?\s*л$/i, '');
        return withoutVolume.trim();
    }

    const groups = {};
    list.forEach(p => {
        const key = normalize(p.ProductName);
        if(!groups[key]) groups[key] = [];
        groups[key].push(p);
    });

    // sort each group by numeric volume if available
    const parseVol = (p) => {
        if(p && p.Volume != null) return Number(p.Volume) || 0;
        const m = (p?.ProductName || '').match(/,\s*(\d+(?:[\.,]\d+)?)\s*л$/i);
        if(m){
            return Number(String(m[1]).replace(',', '.')) || 0;
        }
        return 0;
    };

    return Object.values(groups).map(arr => arr.sort((a,b)=> parseVol(a) - parseVol(b)));
}
